<template>
	<div class="block-inner">
		<header @change="$emit('edit')">
			<div>
				<RichEditor v-model="block.content" :inline="true" :block-id="block.id" :paste-tags="false" placeholder="Write a question" @input="$emit('edit')" />
			</div>
		</header>

		<div class="input-group repeat">
			<draggable v-bind="dragOptions" :list="block.items" @end="$emit('edit')">
				<div v-for="(item, index) in block.items" :key="index" class="input-group-row" @change="$emit('edit')">
					<IconMoveVertical :width="16" :height="16" class="move-item" />
					<input v-model="item.label" type="text" placeholder="Add a label..." />
					<BaseButton type="primary rounded" @click="removeInput(index)">
						<IconCross :width="12" :height="12" />
					</BaseButton>
				</div>
			</draggable>
			<BaseButton type="primary rounded" @click="addInput">
				<IconAdd :width="16" :height="16" />
			</BaseButton>
		</div>
	</div>
</template>

<script>
	import IconAdd from '../icons/IconAdd';
	import IconCross from '../icons/IconCross';
	import IconMoveVertical from '../icons/IconMoveVertical';
	import BaseButton from '../BaseButton';
	import draggable from 'vuedraggable';
	import RichEditor from '../RichEditor';
	import {v4} from 'uuid';

	export default {
		components: {
			IconAdd,
			IconCross,
			IconMoveVertical,
			BaseButton,
			draggable,
			RichEditor
		},
		props: {
			block: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				dragOptions: {
					animation: 200,
					disabled: false,
					direction: 'vertical',
					handle: '.move-item',
					tag: 'section',
					class: {
						'input-group-rows': true
					}
				}
			};
		},
		created() {
			if(!Array.isArray(this.block.items)) {
				this.$set(this.block, 'items', [this.defaultItem()]);
			}
		},
		methods: {
			addInput() {
				this.block.items.push(this.defaultItem());
			},
			removeInput(index) {
				this.block.items.splice(index, 1);
				this.$emit('edit');
			},
			defaultItem() {
				return {
					id: v4(),
					label: ''
				};
			}
		}
	};
</script>

<style lang="scss" scoped>
	header {
		margin-bottom: $default_padding/2;
	}

	.input-group {
		display: flex;
		flex-flow: column nowrap;

		.input-group-row {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			margin-bottom: 10px;

			input,
			.bool-input {
				margin: 0;
			}

			input,
			.button,
			.bool-input {
				margin-left: 10px;
			}

			.button {
				button {
					padding: 5px;
				}
			}
		}

		& > .button {
			align-self: center;
		}

		button {
			background-color: $color__dark;

			&:hover {
				background-color: rgba($color: $color__dark, $alpha: 0.8);
			}
		}
	}
</style>